window.addEventListener("DOMContentLoaded", (event) => {
    function targetBlank() {
        var internal = location.host.replace("www.", "");
        internal = new RegExp(internal, "i");
        var a = document.getElementsByTagName('a'); // grab every link on the page
        for (var i = 0; i < a.length; i++) {
          var href = a[i].host; // set the host of shopify link
          if( !internal.test(href) ) { // make sure the href of a element in loop doesn't contain current site's host
            a[i].setAttribute('target', '_blank'); // if it doesn't, set attribute
          }
        }
    };
    // Run the function targetBlank()
    targetBlank();

  // footer expanded
    function footerAccordions() {
    const footerElements = document.querySelectorAll('.footer-block--menu .footer-block__heading');
       footerElements.forEach(footerElement => {
          footerElement.addEventListener('click', function() {
            const nearestElement = footerElement.nextElementSibling;
            footerElement.classList.toggle('v-header-collapsed');
            nearestElement.classList.toggle('v-footer-collapsed');
          });
        });
    }
    footerAccordions();

  // megamenu opener on mouseeover
  function vlMegaMenuOpener() {
    const megaOpener = document.getElementsByClassName("v-megamenu-details");
    const megaElHover = document.getElementsByClassName("v-megamenu-cont");

    for (let i = 0; i < megaOpener.length; i++) {
      // Add event listener to open the menu when mouse hovers over the opener element
      megaOpener[i].addEventListener("mouseover", () => {
        megaOpener[i].setAttribute("open", true);

        // Add event listener to keep the menu open when mouse hovers over the content element
        megaElHover[i].addEventListener("mouseover", () => {
          megaOpener[i].setAttribute("open", true);
        });

        // Add event listener to close the menu when mouse leaves the content element
        megaElHover[i].addEventListener("mouseleave", () => {
          megaOpener[i].removeAttribute("open");
        });

        // Add event listener to close the menu when mouse leaves the opener element
        megaOpener[i].addEventListener("mouseleave", () => {
          megaOpener[i].removeAttribute("open");
        });
      });
    }
  }

  // script for featured products with navbar
  function bimgwtextFunction() {
    const vBimgwtextName = document.querySelectorAll('.v-bimgwtext-name');
    const vBimgwtextBlock = document.querySelectorAll('.v-bimgwtext-block');
    vBimgwtextName[0].style.opacity = "1";
    vBimgwtextBlock[0].style.display = "flex";
    function removeAllActiveInstances() {
      for (let i = 0; i < vBimgwtextBlock.length; i++) {
        vBimgwtextBlock[i].style.display = "none";
        vBimgwtextName[i].style.opacity = "0.3";
        }
      };

    for (let i = 0; i < vBimgwtextName.length; i++) {
      vBimgwtextName[i].addEventListener('click', function() {
        removeAllActiveInstances();
        for (let j = 0; j < vBimgwtextBlock.length; j++) {
          if (i === j) {
            vBimgwtextBlock[j].style.display = "flex";
            vBimgwtextName[j].style.opacity = "1";
          } else {
            vBimgwtextBlock[j].style.display = "none";
            vBimgwtextName[j].style.opacity = "0.3";
          }
        }
      });
    }
  }

  // owl carousel script for featured collection slider section
  $('.v-featcol-slider-div').owlCarousel({
    loop:true,
    margin:10,
    dots: false,
    responsive:{
        0:{
            items:1
        },
        200:{
            items:1.5
        },
        500:{
            items:2.5
        },
        1000:{
            items:3.5
        },
        1100:{
            items:4.5
        }
    }
  })

  // owl carousel script for columns section
  $('.v-textcolumns-slider').owlCarousel({
    loop:true,
    margin:10,
    dots: false,
    responsive:{
        0:{
            items:1
        },
        200:{
            items:1.5,
            center: true
        },
        500:{
            items:3
        },
        1000:{
            items:4
        },
        1100:{
            items:5
        }
    }
  })

  vlMegaMenuOpener();
  if(document.querySelectorAll('.v-bimgwtext-name') != null) {
    bimgwtextFunction();
  }

  const myInterval = setInterval(myTimer, 1000);
    function myTimer() {
      if(document.querySelector('.swym-wishlist-button-bar') != null) {
        document.querySelector('quantity-input').after(document.querySelector('.swym-wishlist-button-bar'))
        clearInterval(myInterval);
      }
    }


});

